﻿module Shared.Branding

type Branding =
  | ICON
  | TRANSASH
  | SV

let parse (brand: string) =
  match brand |> Option.ofObj |> Option.map (fun x -> x.ToUpper()) |> Option.defaultValue "" with
  | "ICON" -> ICON
  | "TRANSASH" -> TRANSASH
  | _ -> SV